import * as commonFnc from '../common/commonFnc';





/**
 * 対象者の承認順序を取得する。
 * @param {Array} Department_msts 部署情報一覧
 * @param {user} targetUserData 勤怠のユーザ情報
 * @param {String} login_user_id ログインユーザID
 * @returns なし
 */
export function getApprovalOder(Department_msts, targetUserData, login_user_id){
    
    let targetDepartment = Department_msts.find(p=>p.department_cd === targetUserData.department_cd);

    if( targetUserData.second_approval_userid === login_user_id){
        // ユーザの二次承認に設定されている。
        return "second";
    }else if( targetUserData?.first_approval_userid === login_user_id ){
        // ユーザの一次承認に設定されている。
        return "first";
    }else if( targetDepartment.second_approval_userid === login_user_id ){
        // 部署の二次承認に設定されている。
        return "second";
    }else if( targetDepartment.first_approval_userid === login_user_id ){
        // 部署の一次承認に設定されている。
        return "first";
    }
    return "";
}

// summary: 次回承認者を取得する。
// param1 : User User 対象のユーザ情報
// param1 : Department_msts Department_msts 部署マスタ一覧
// param1 : String approval_status_cd 現在の承認状況
// param1 : String approvalOrder 承認順序
// return : String next_approval_userid 次回承認者id
export function getNextApprovalUser(User, Department_msts, approval_status_cd, approvalOrder) {

    if(!User || !Department_msts || !approval_status_cd){
        return ;
    }
    

    const myDep = Department_msts.find( depmst => depmst.department_cd === User.department_cd);

    if(approvalOrder === "second"){
        return "";
    }else if(approvalOrder === "first"){
        return User.second_approval_userid || myDep.second_approval_userid;
    }


    // 差戻しの場合は現在の承認ステータスに関わらずbackが渡される。
    
    
    if(approval_status_cd === "10" || approval_status_cd === "80"){
        if(User?.first_approval_userid && User.first_approval_userid !== ""){
            return User.first_approval_userid;
        }else if(myDep?.first_approval_userid && myDep.first_approval_userid !== ""){
            return myDep.first_approval_userid;
        }
    }else if(approval_status_cd === "20"){
        if(User?.second_approval_userid && User.second_approval_userid !== ""){
            return User.second_approval_userid;
        }else if(myDep?.second_approval_userid && myDep.second_approval_userid !== ""){
            return myDep.second_approval_userid;
        }
    }else{
        return "";
    }

    // if(approval_status_cd === "10" || approval_status_cd === "80"){

    //     if(User.first_approval_userid || User.first_approval_userid === undefined || User.first_approval_userid === ""){
    //         return myDep.first_approval_userid;
    //     }else{
    //         return User.first_approval_userid;
    //     }

    // }else if(approval_status_cd === "20"){

    //     if(User.second_approval_userid || User.second_approval_userid === undefined || User.second_approval_userid === ""){
    //         return myDep.second_approval_userid;
    //     }else{
    //         return User.second_approval_userid;
    //     }
    // }

    return ;
}

// summary: 前回承認者を取得する。※承認者の取消はbl_approval.jsのrequestCancelで行う。
// param1 : User User 対象のユーザ情報
// param1 : Department_msts Department_msts 部署マスタ一覧
// param1 : String approval_status_cd 現在の承認状況
// param1 : String approvalOrder 承認順序
// return : String next_approval_userid 前回承認者id
export async function getBeforeApprovalUser(User, Department_msts, approval_status_cd, approvalOrder) {

    if(!User || !Department_msts || !approval_status_cd){
        return ;
    }

    const myDep = Department_msts.find( depmst => depmst.department_cd === User.department_cd);

    if(approvalOrder === "second" || approvalOrder === "first"){
        return "";
    }

    if(approval_status_cd === "90"){
        // 確定の場合は二次承認者を取得

        if(User.second_approval_userid || User.second_approval_userid === undefined || User.second_approval_userid === ""){
            return myDep.second_approval_userid;
        }else{
            return User.second_approval_userid;
        }

    }else if(approval_status_cd === "30"){
        // 二次待ち：30で取り消しの場合は一次承認者を取得

        if(User.first_approval_userid || User.first_approval_userid === undefined || User.first_approval_userid === ""){
            return myDep.first_approval_userid;
        }else{
            return User.first_approval_userid;
        }
    }else{

        return ;
    }
    
}

// summary: 次回承認CDを取得する。
// param1 : String nowApprovalcd 現在の承認CD
// return : String next_approval_userid 次回承認CD
/**
 * 次回承認CDを取得する。
 * @param {String} nowApprovalcd 現在の承認CD
 * @param {String} approvalOrder ログインユーザの承認順序
 * @returns {String} next_approval_cd 次回承認CD
 */
export function getNextApprovalCd(nowApprovalcd, approvalOrder) {

    var nextcd = "0";

    if(approvalOrder === "second"){
        // 二次承認者は即確定
        nextcd = "90";

    }else if(approvalOrder === "first"){
        // 一次承認者は二次承認待ち
        nextcd = "30";

    }else{
        // その他は通常ルート
        if(nowApprovalcd === "10" || nowApprovalcd === "80" || nowApprovalcd === null || nowApprovalcd === undefined){
            nextcd = "20";
        }else if(nowApprovalcd === "20"){
            nextcd = "30";
        }else if(nowApprovalcd === "30"){
            nextcd = "90";
        }else{
            nextcd = "10";
        }

    }


    return nextcd;
}

// summary: 前回承認CDを取得する。本人キャンセルのロジック ※承認者の取消はbl_approval.jsのrequestCancelで行う。
// param1 : String nowApprovalcd 現在の承認CD
// param1 : String approvalOrder 承認順序
// return : String next_approval_userid 前回承認CD
export function getBeforeApprovalCd (nowApprovalcd, approvalOrder) {

    var nextcd = "0";

    
    if(approvalOrder === "second" || approvalOrder === "first"){
        return "10";
    }

    if(nowApprovalcd === "30"){
        nextcd = "20";
    }else if(nowApprovalcd === "20"){
        nextcd = "10";
    }else if(nowApprovalcd === "90"){
        nextcd = "30";
    }else{
        nextcd = "";
    }

    return nextcd;
}


/**
 * 承認申請をする。
 * @param {Kintai_bsc} target_kintai_bsc 対象の勤怠情報
 * @param {Array} Department_msts 部署情報一覧
 * @param {Obj} setKintai_bscs 勤怠情報のセッター
 * @param {String} first_approval_userid 初回承認者
 * @param {String} second_approval_userid 次回承認者
 */
export async function requestApproval (target_kintai_bsc, Department_msts, setKintai_bscs, first_approval_userid, second_approval_userid) {

    // ユーザ情報を取得し、次回承認者と次回承認CDを更新する。
    const query = new URLSearchParams({user_id: target_kintai_bsc.user_id});

    let res = await fetch(`/api/select/user?${query}`);
    let targetUserData = await res.json();
    let approvalOrder = getApprovalOder(Department_msts, targetUserData, target_kintai_bsc.user_id);
    let nextid = getNextApprovalUser(targetUserData, Department_msts, target_kintai_bsc.approval_status_cd, approvalOrder);
    let nextcd = getNextApprovalCd(target_kintai_bsc.approval_status_cd, approvalOrder);

    updateKintaiApprovalInfo(
        setKintai_bscs,
        target_kintai_bsc.user_id,
        target_kintai_bsc.date,
        nextid,
        nextcd,
        first_approval_userid,
        second_approval_userid
    );

}


/**
 * 取消申請をする。
 * @param {Kintai_bsc} target_kintai_bsc 対象の勤怠情報
 * @param {Array} Department_msts 
 * @param {Obj} setKintai_bscs 勤怠情報のセッター
 */
export async function requestCancel(target_kintai_bsc, Department_msts, setKintai_bscs) {

    // ユーザ情報を取得し、次回承認者と次回承認CDを更新する。
    const query = new URLSearchParams({user_id: target_kintai_bsc.user_id});
    let res = await fetch(`/api/select/user?${query}`);
    let targetUserData = await res.json();
    let approvalOrder = getApprovalOder(Department_msts, targetUserData, target_kintai_bsc.user_id);
    let beforeid = getBeforeApprovalUser(targetUserData, Department_msts, target_kintai_bsc.approval_status_cd, approvalOrder);
    let beforecd = getBeforeApprovalCd(target_kintai_bsc.approval_status_cd, approvalOrder);

    updateKintaiApprovalInfo(
        setKintai_bscs,
        target_kintai_bsc.user_id,
        target_kintai_bsc.date,
        beforeid,
        beforecd,
        target_kintai_bsc.first_approval_userid,
        target_kintai_bsc.second_approval_userid
    );

}

export async function updateKintaiApprovalInfo (setKintai_bscs,target_user_id, target_date, target_approval_userid, target_approvalcd, first_approval_userid, second_approval_userid){

    // 勤怠情報の承認CDと次回承認者を更新する。
    const bodyParam = new URLSearchParams({
        user_id:target_user_id, 
        date:commonFnc.formatDate(target_date), 
        next_approval_userid: target_approval_userid, 
        approval_status_cd: target_approvalcd,
        last_approval_userid: target_user_id, 
        first_approval_userid: first_approval_userid,
        second_approval_userid: second_approval_userid
    });

    // 更新
    const params = {method : "POST", body : bodyParam};
    await fetch(`/api/insert/kintai_bsc2`, params);

    // データ再取得
    const queryKintai = new URLSearchParams({login_user_id: target_user_id});
    const res = await fetch(`/api/select/kintai_bsc?${queryKintai}`);
    const data = await res.json();
    setKintai_bscs(data);

    // const params = {method : "POST", body : bodyParam};
    // fetch(`/api/insert/kintai_bsc2`, params)
    // .then(()=>{
    //     // 画面表示を更新する。
    //     const queryKintai = new URLSearchParams({login_user_id: target_user_id});
    //     fetch(`/api/select/kintai_bsc?${queryKintai}`)
    //     .then((res) => res.json())
    //     .then((data) => setKintai_bscs(data));
    // });
}